class Timepicker {

    constructor() {
        jQuery('[data-timepicker]').timepicker({
            timeFormat: 'HH:mm',
            interval: 60,
            minTime: '00:00',
            maxTime: '23:00',
            // defaultTime: '00:00',
            // startTime: '00:00',
            dynamic: false,
            dropdown: true,
            scrollbar: true
        });
    }
}